import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//import update from "immutability-helper";
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TimeClockPermissionContainer from '../../containers/TimeClock/TimeClockPermission';
import DriverReportContainer from '../../containers/Reporting/DriverReports';

import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';

//- UI / Form
import FormComponent from '../../components/FormComponent';
import EnhancedTable from '../../components/table/EnhancedTable';
import { statuses } from '../../components/FleetCalendar/WorkDayStatuses';
import { pToC, lateToColor, formatPercentage, noNsToColor } from './helper';
import { Tooltip } from '@material-ui/core';

const isWorkingStatusMap = {};
const statusToDisplay = {};
statuses.forEach(({ value, display, isWorking }) => {
	if (isWorking) {
		isWorkingStatusMap[value] = true;
	}
	statusToDisplay[value] = display;
});
statusToDisplay.daysWorked = 'Total Days Working';
statusToDisplay.daysNotWorked = 'Total Days Not Working';
statusToDisplay.late = 'Late';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		label: {
			padding: 5,
			paddingRight: 2,
			fontWeight: 500,
			textAlign: 'right',
			fontSize: 18,
		},
		value: {
			padding: 5,
			paddingLeft: 10,
			paddingRight: 10,
			fontSize: 18,
		},
		stat: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
		},
		dateNote: {
			color: '#666',
			fontSize: 13,
		},
		noteContainer: {
			borderBottom: '1px solid #f5f5f5',
		},
	};
};

class DriverReportDetails extends FormComponent {
	constructor(props) {
		super(props);

		const afterDate = _.get(this.props, 'match.params.afterDate');
		const beforeDate = _.get(this.props, 'match.params.beforeDate');
		const userId = parseInt(_.get(this.props, 'match.params.userId'));
		const locationId = parseInt(_.get(this.props, 'match.params.locationId'));

		this.state = {
			afterDate,
			beforeDate,
			locationId,
			userId,
		};
	}

	componentDidMount() {
		this.handleSearch();
	}

	handleSearch = () => {
		const { showErrors, runDriverDetailReport } = this.props;

		this.setState({
			isSearching: true,
			refreshId: this.state.refreshId + 1,
			hasResults: true,
		});

		const { afterDate, beforeDate, locationId, userId } = this.state;

		runDriverDetailReport({
			params: {
				userIds: [userId],
				locationIds: [locationId],
				afterDate,
				beforeDate,
			},
			callback: (err, r) => {
				this.setState({ isExporting: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				this.setState({ isSearching: false });
				this.formatResults({ apiResults: r });
			},
		});
	};

	formatResults = ({ apiResults }) => {
		const { userMap, classes } = this.props;

		const { driverReportRows, workDayIds, collections } = apiResults;
		const { workDayCollection, shiftCollection, equipmentCollection } = collections;
		const workDayLookup = _.keyBy(workDayCollection, 'workDayId');
		const shiftMap = _.keyBy(shiftCollection, 'shiftId');
		const equipmentMap = _.keyBy(equipmentCollection, 'equipmentId');

		const formattedRows = [];
		workDayIds.forEach((workDayId) => {
			const workDay = workDayLookup[workDayId];

			const {
				date,
				// equipmentId,
				isLate,
				// locationId,
				shiftId,
				// shiftTime,
				equipmentAssignmentId,
				status,
				notes,
				// userAssignmentId,
			} = workDay;

			const row = {
				key: workDayId,
				date,
				dateDisplay: moment(date).format('M/D/YY'),
				late: isLate,
				lateDisplay: isLate ? <CheckIcon style={{ color: 'red' }} /> : '-',
				statusDisplay: statusToDisplay[status],
				shiftId,
				shiftDisplay: shiftMap[shiftId] ? shiftMap[shiftId].display : '-',
				equipmentDisplay: equipmentMap[equipmentAssignmentId]
					? equipmentMap[equipmentAssignmentId].display
					: 'TBD',
			};

			if (!_.isEmpty(notes)) {
				row.noteCount = notes.length;
				row.notesDisplay = (
					<div>
						{notes.map((workDayNote) => {
							const { workDayNoteId, creatorUserId, note, dateCreated } = workDayNote;
							const creatorUser = userMap[creatorUserId] || {
								firstName: 'Missing',
								lastName: '',
							};
							const dateFormatted = moment(dateCreated).format('M/D h:mm a');
							return (
								<div className={classes.noteContainer} key={workDayNoteId}>
									<div>
										<strong>
											{creatorUser.firstName} {creatorUser.lastName}{' '}
										</strong>
										said "{note}"
									</div>
									<div className={classes.dateNote}>{dateFormatted}</div>
								</div>
							);
						})}
					</div>
				);
			} else {
				row.noteCount = 0;
				row.notesDisplay = <div style={{ color: '#666', fontStyle: 'italic' }}>none</div>;
			}

			formattedRows.push(row);
		});

		// format the top part
		const driverReportRow = _.first(driverReportRows);
		const { userId, daysWorked, daysNotWorked, percentageWorked, countByStatus } = driverReportRow;

		const user = userMap[userId] || {
			firstName: 'Missing',
			lastName: userId,
		};
		const driverDisplay = `${user.firstName} ${user.lastName}`;
		const row = {
			driverDisplay,
			daysWorked,
			daysNotWorked,
			percentageWorked,
			percentageWorkedDisplay: formatPercentage(percentageWorked || 0),
			late: countByStatus.late || 0,
		};

		statuses.forEach(({ value, isWorking }) => {
			let count = 0;
			if (countByStatus[value]) {
				count = countByStatus[value];
			}
			row[value] = count;
		});
		this.setState({ formattedRows, driverStats: row });
	};

	render() {
		const { permissions, classes } = this.props;
		const { afterDate, beforeDate, userId } = this.state;

		if (!permissions || !_.includes(permissions, 'canRunAttendanceReports')) {
			return <div>You do not have valid permissions to view this page.</div>;
		}

		if (!afterDate || !beforeDate || !userId) {
			return <div>Invalid URL</div>;
		}
		return (
			<>
				<div className={classes.globalMainHeadline}>Driver Detail Report</div>
				<Paper className={classes.globalMainPaper}>{this.renderStats()}</Paper>
				<div className={classes.globalMainHeadline}>Day by Day Breakdown</div>
				<Paper className={classes.globalMainPaper}>{this.renderResults()}</Paper>
			</>
		);
	}

	renderStats = () => {
		const { classes } = this.props;
		const { driverStats } = this.state;
		if (!driverStats) {
			return null;
		}

		const { driverDisplay } = driverStats;
		return (
			<div>
				<div style={{ fontSize: 28, marginBottom: 10 }}>Driver: {driverDisplay}</div>

				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
					}}
				>
					<div>
						<div className={classes.stat} style={{ fontSize: 20 }}>
							<div className={classes.label}>Percentage Worked</div>
							<div
								className={classes.value}
								style={{
									backgroundColor: pToC(driverStats.percentageWorked),
								}}
							>
								{driverStats.percentageWorkedDisplay}
							</div>
							<div>
								<Tooltip
									title={
										<div style={{ fontSize: 16, lineHeight: 1.2, padding: 10 }}>
											Out of the total days possible, what percentage was the driver working.
											"Average" is based on working 10 out of 15 days (66.6%) because of the 5/2 5/3
											schedule.
										</div>
									}
								>
									<InfoIcon
										style={{
											cursor: 'pointer',
											fontSize: 18,
											color: '#1289d4',
										}}
									/>
								</Tooltip>
							</div>
						</div>
						<div>
							{['daysWorked', 'daysNotWorked'].map((status) => {
								return (
									<div className={classes.stat} key={status}>
										<div className={classes.label}>{statusToDisplay[status]}</div>
										<div className={classes.value}>{driverStats[status]}</div>

										<div>
											<Tooltip
												title={
													<div
														style={{
															fontSize: 16,
															lineHeight: 1.2,
															padding: 10,
														}}
													>
														Working is considered: scheduled work day, extra days, swap on. All
														other status are Not Working.
													</div>
												}
											>
												<InfoIcon
													style={{
														cursor: 'pointer',
														fontSize: 18,
														color: '#1289d4',
													}}
												/>
											</Tooltip>
										</div>
									</div>
								);
							})}
						</div>
					</div>

					<div>
						{['late', 'noCallNoShow', 'callOut'].map((status) => {
							return (
								<div className={classes.stat} key={status}>
									<div className={classes.label}>{statusToDisplay[status]}</div>
									<div
										className={classes.value}
										style={{
											backgroundColor:
												status === 'late'
													? lateToColor(driverStats.late)
													: status === 'noCallNoShow'
													? noNsToColor(driverStats.noNsToColor)
													: 'none',
										}}
									>
										{driverStats[status]}
									</div>
								</div>
							);
						})}
					</div>
					<div>
						{['extraDay', 'swapOn', 'swapOff', 'modifiedDay'].map((status) => {
							return (
								<div className={classes.stat} key={status}>
									<div className={classes.label}>{statusToDisplay[status]}</div>
									<div className={classes.value}>{driverStats[status]}</div>
								</div>
							);
						})}
					</div>
					<div style={{ paddingRight: 40 }}>
						{['pto', 'fmla', 'wc', 'loa'].map((status) => {
							return (
								<div className={classes.stat} key={status}>
									<div className={classes.label}>{statusToDisplay[status]}</div>
									<div className={classes.value}>{driverStats[status]}</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	};

	renderResults = () => {
		const { formattedRows } = this.state;
		if (!formattedRows) {
			return null;
		}

		/* 
    TODO 
      At the top I want to make the OTHER API call to show the stats breakdown on this page
      
      -I want to show the time of the shift and the type (night vs day)
      -I also want to show the truck they are
      -Need to show if they are LATE or not in its own column
      -Need a final column for notes
    */

		const columns = [
			{
				label: 'Date',
				sortId: 'date',
				displayId: 'dateDisplay',
			},
			{
				label: 'Status',
				sortId: 'statusDisplay',
				displayId: 'statusDisplay',
			},
			{
				label: 'Late',
				sortId: 'lateDisplay',
				displayId: 'lateDisplay',
			},
			{
				label: 'Shift',
				sortId: 'shiftDisplay',
				displayId: 'shiftDisplay',
			},
			{
				label: 'Truck',
				sortId: 'equipmentDisplay',
				displayId: 'equipmentDisplay',
			},
			{
				label: 'Notes',
				sortId: 'noteCount',
				displayId: 'notesDisplay',
			},
		];

		return (
			<EnhancedTable
				rows={formattedRows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'userId'}
				defaultOrder={'desc'}
			/>
		);
	};
}

DriverReportDetails.propTypes = {
	runDriverDetailReport: PropTypes.func.isRequired,
	userMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	DriverReportContainer,
	TimeClockPermissionContainer,
])(DriverReportDetails);
